import { Paper } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IFilteringViewModel } from "../../_common/interface/table";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formService } from "../../_services/form.service";
import { getDate } from "../../_helpers/dateTime.helper";
import { userCreditService } from "../../_services/userCredit.service";
import { accountService } from "../../_services/accounts.service";
import { observer } from 'mobx-react-lite';
import { GENERAL_STORE } from "../../_stores/general.store";

export const UserProfileUserCreditsList = observer(() => {

    const { userId } = useParams<{ userId: string }>();

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        name: '',
    });

    let navigate = useNavigate();

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'userName',
                header: 'User',
            },
            {
                accessorKey: 'createdBy',
                header: 'Created By',
            },
            {
                accessorKey: 'eventDate',
                header: 'Event Date',
                accessorFn: (rowData: any) => <>{rowData.eventDate ? getDate(rowData.eventDate) : "-"}</>,
            },
            {
                accessorKey: 'usedDate',
                header: 'Used Date',
                accessorFn: (rowData: any) => <>{rowData.usedDate ? getDate(rowData.usedDate) : "-"}</>,
            },
        ],
        [],
    );


    useEffect(() => {
        fetchData();
    }, [filter, GENERAL_STORE.getUserCreditRefreshCounter]);

    function fetchData() {
        setLoading(true);
        return userCreditService.getAll({ ...filter, userId: userId })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    const asd = accountService.isAdmin ? { onEdit: (id: any) => { navigate(`${id}`) } } : {};

    return (
        <>
            <PageHeader
                pageName="My User Credits"
                actionType="create"
            />
            <Paper>
                <CommonTable
                    {...asd}
                    columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                    isLoading={isLoading}
                // onEdit={accountService.isAdmin ? (id) => { navigate(`${id}`) } : () => { }}
                />
            </Paper>
        </>
    );

});
